import { render, staticRenderFns } from "./_updateTaskTypeModal.vue?vue&type=template&id=16eaf3da"
import script from "./_updateTaskTypeModal.vue?vue&type=script&lang=js"
export * from "./_updateTaskTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports